import { SvgBox, SvgBoxProps } from "@govlaunch/web";
import React from "react";

export default function MyProjectsIcon(props: SvgBoxProps) {
  return (
    <SvgBox width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="10.75" stroke="#3F4A5A" strokeWidth="2.5" />
      <path
        d="M14.7694 10.1538C14.7694 11.6832 13.5296 12.923 12.0002 12.923C10.4708 12.923 9.23096 11.6832 9.23096 10.1538C9.23096 8.62435 10.4708 7.38452 12.0002 7.38452C13.5296 7.38452 14.7694 8.62435 14.7694 10.1538Z"
        fill="#3F4A5A"
      />
      <path
        d="M14.7694 10.1538C14.7694 11.6832 13.5296 12.923 12.0002 12.923C10.4708 12.923 9.23096 11.6832 9.23096 10.1538C9.23096 8.62435 10.4708 7.38452 12.0002 7.38452C13.5296 7.38452 14.7694 8.62435 14.7694 10.1538Z"
        stroke="#3F4A5A"
      />
      <mask id="path-4-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.69238 20.2181C4.56461 16.5635 7.85164 13.8462 11.7733 13.8462C15.9684 13.8462 19.4373 16.9556 20.0009 20.9954C17.9509 22.8621 15.2258 24 12.2349 24C8.84867 24 5.80315 22.5414 3.69238 20.2181Z"
        />
      </mask>
      <path
        d="M3.69238 20.2181L0.774341 19.5217L0.406529 21.0628L1.47194 22.2354L3.69238 20.2181ZM20.0009 20.9954L22.0207 23.2136L23.1908 22.1482L22.9721 20.5809L20.0009 20.9954ZM6.61042 20.9145C7.16767 18.5797 9.27174 16.8462 11.7733 16.8462V10.8462C6.43155 10.8462 1.96155 14.5474 0.774341 19.5217L6.61042 20.9145ZM11.7733 16.8462C14.451 16.8462 16.67 18.8318 17.0297 21.41L22.9721 20.5809C22.2046 15.0794 17.4858 10.8462 11.7733 10.8462V16.8462ZM17.9811 18.7772C16.4619 20.1605 14.4499 21 12.2349 21V27C16.0017 27 19.4399 25.5636 22.0207 23.2136L17.9811 18.7772ZM12.2349 21C9.72922 21 7.47896 19.9246 5.91282 18.2008L1.47194 22.2354C4.12733 25.1582 7.96812 27 12.2349 27V21Z"
        fill="#3F4A5A"
        mask="url(#path-4-inside-1)"
      />
    </SvgBox>
  );
}
